module.exports = __webpack_public_path__ + "static/media/SMS-qrcode.c011a0d8.png";